import ListingType from './listing-type';
var BrowseContext = {
  [ListingType.SALES_RESIDENTIAL.name]: 'browse-sale',
  [ListingType.RENTAL_RESIDENTIAL.name]: 'browse-rent',
  [ListingType.RENTAL_COMMERCIAL.name]: 'browse-commercial-rent',
  [ListingType.SALES_COMMERCIAL.name]: 'browse-commercial-sale',
  [ListingType.SALES_BUSINESS.name]: 'browse-business',
  [ListingType.SHARE_RESIDENTIAL.name]: 'browse-share',
  [ListingType.DEVELOPMENTS_RESIDENTIAL.name]: 'browse-new-homes',
  [ListingType.OFF_MARKET.name]: null,
  [ListingType.SALES_EARLY_ACCESS.name]: null
};
var ListingTypeByBrowseContext = Object.keys(BrowseContext).reduce((map, listingTypeKey) => {
  var key = BrowseContext[listingTypeKey];
  if (key != null) {
    map[key] = listingTypeKey;
  }
  return map;
}, {});
export default BrowseContext;
export { ListingTypeByBrowseContext };